import { z } from "zod"

function unwrapEffects<T extends z.ZodTypeAny>(schema: T): T {
    // if schema is an instance of ZodEffects, recursively unwrap the inner schema
    if (schema instanceof z.ZodEffects) {
        return unwrapEffects(schema._def.schema);
    }

    // if schema is an instance of ZodReadonly, recursively unwrap the inner schema
    if (schema instanceof z.ZodReadonly) {
        return unwrapEffects(schema._def.innerType);
    }

    // return the unwrapped schema
    return schema;
}

export function getZodObjectDefaults<T extends z.AnyZodObject>(schema: T | z.ZodEffects<T>): Partial<z.infer<T>> {

    // unwrap ZodEffects to get the base schema
    const baseSchema = unwrapEffects(schema) as z.AnyZodObject;

    // return an object with the default values for each field in the schema
    return Object.fromEntries(
        Object.entries(baseSchema.shape as Record<string, z.ZodTypeAny>).map(([key, value]) => {
            const fieldSchema = unwrapEffects(value);

            // if the field schema has a default value return it
            if (fieldSchema instanceof z.ZodDefault) {
                return [key, fieldSchema._def.defaultValue()];
            }

            // otherwise return undefined
            return [key, undefined];
        })
    ) as Partial<z.infer<T>>;
}